const cache = {
  get (key) {
    return this.evil(localStorage.getItem(key))
  },

  set (key, value) {
    return localStorage.setItem(key, JSON.stringify(value))
  },

  remove (key) {
    return localStorage.removeItem(key)
  },

  evil (fn) {
    let Fn = Function
    return new Fn('return ' + fn)()
  },

  clear () {
    localStorage.clear()
  }
}
export default cache
